import * as React from "react";
import { withTheme } from "../../../../../../common/withTheme";
import InternalClassificationLink from "../../../../Common/Links/InternalClassificationLink";

class PageJoinApmn extends React.PureComponent<any, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <>
                <h2>Things to Consider before You Join APMN</h2>
                <p>Before you register as an APMN volunteer, please ask yourself the following:</p>
                <h3>Do I know what to look for when spotting a platypus in the wild, including how its appearance differs from other aquatic animals such as water-rats (aka rakali)?</h3>
                <p>
                    If the answer is NO, please go to 
                    {" "}
                    {InternalClassificationLink("spot-a-platypus", "How to Spot a Platypus in the Wild", undefined, undefined)}
                    {" "}
                    for more information.
				</p>
                <h3>Can I devote enough time to APMN?</h3>
                <p>
                    You don't have to watch for platypus every day to contribute to APMN.  Once or twice a week is fine, though you can certainly monitor more often if you have the time to do so.  
				</p>
                <p>
                    Similarly, a standard monitoring session takes just 5-10 minutes to complete per site.
				</p>
                <p>
                    Many APMN participants fit their platypus monitoring sessions into other day-to-day activities, such as taking walks, biking to and from work, or checking a stock pump. 
				</p>
                <p>
                    Be careful not to over-commit to the amount of regular monitoring you can do.  It's generally best to start with one (or possibly a few) sites and then add more later if you wish.  Most participants monitor between 1 and 3 sites (though sometimes up to 5 or 6 sites). 
				</p>
                <p>
                    If you have to make a lengthy special trip to travel to the place where you plan to watch for platypus, you may find it's difficult to keep up with routine monitoring.  If you're not sure, try to carry out a few preliminary platypus-spotting sessions before you register, to help decide if the program will work for you.
                </p>
                <h3>Do I know of suitable and accessible monitoring sites (one or more) where platypus can be seen?</h3>
                <p>
                    Platypus monitoring will be most worthwhile if you have a reasonably high chance of spotting an animal – say, if at least one sighting is recorded on average in 20 or 25 visits to a site.  If you know that platypus live in a nearby river or creek but aren't sure where you should watch for them, start by asking people in your community where platypus have been seen in the past, and then (based on this information) see if you can locate one or more places where the animals are now active. For more hints about good places to watch for these animals, see {InternalClassificationLink("choose-monitoring-site", "Choosing a Monitoring Site.", undefined, undefined)}
				</p>
                <h3>I'm ready to join APMN. How do I get started?</h3>
                <p>
                If you’re confident that you (1) know how to identify a platypus in the wild, (2) know of one or more suitable sites to watch for the animals and (3) are ready to start monitoring, please go straight to
                    {InternalClassificationLink("register", " APMN Volunteer Registration", undefined, undefined)}.
				</p>
                <h3>How can I report platypus sightings if I decide not to join APMN?</h3>
                <p>
                    You can report details of platypus sightings either directly to the national wildlife database Atlas of Living Australia (using the iNaturalist app) or through the APC website <a href="https://platypus.asn.au/report-a-sighting/" target="_blank">Report a Sighting</a> page. We’ll get back to you if more details are needed, then submit the information to the Atlas of Living Australia on your behalf.
				</p>
            </>
        );
    }
}

export default withTheme<any>(PageJoinApmn);
